<template>
  <div>
    <v-app id="inspire">
      <v-navigation-drawer
        fixed
        :clipped="$vuetify.breakpoint.mdAndUp"
        app
        v-model="drawer"
      >
        <v-list dense>
          <template v-for="item in items">
            <v-layout
              row
              v-if="item.heading"
              align-center
              :key="item.heading">
              </v-layout>
            <router-link :to="'/' + item.route" class="notActivated" active-class="activated">
            <v-list-tile :key="item.text">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            </router-link>
          </template>
          <br/>
          <br/>
          <br/>
          <br/>
          <p class="text-xs-center"><b>Eingeloggt als:</b>
          <br/>
            {{ user.user }}
            <br/>
            {{ user.email }}
            <br/>
            <br/>
            <v-btn flat small @click="logoutClick()">Logout</v-btn>
          </p>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar
        color="blue darken-3"
        dark
        app
        :clipped-left="$vuetify.breakpoint.mdAndUp"
        fixed
      >
        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <span class="hidden-sm-and-down">LieferMax Maps</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-text-field
            clearable
            placeholder="Ladescheinnummer"
            append-outer-icon="search"
            single-line
            v-model="shortcutTextfield"
            :error="shortcutTextfieldError"
            :error-messages="shortcutTextfieldErrorMessage"
          ></v-text-field>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-container fluid>
          <v-layout justify-center align-center>
          <router-view/>
          </v-layout>
        </v-container>
      </v-content>
      <v-dialog v-model="showDetail" transition="dialog-bottom-transition" max-width="70vw">
        <TourDetail :key="tourDetailKey" v-model="showDetail" style="height: 90vh;"></TourDetail>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
import { router, authHeader } from '../_helpers';
import { settings } from '../settings';
import TourDetail from './TourDetail.vue';
export default {
  name: 'home',
  components: {
    TourDetail
  },
  data: () => ({
    shortcutTextfield: '',
    tourDetailKey: 0,
    shortcutTextfieldError: false,
    shortcutTextfieldErrorMessage: '',
    showDetail: false,
    drawer: null,
    items: [
      { icon: 'dashboard', text: 'Dashboard', route: 'dashboard' },
      { icon: 'location_on', text: 'Livetracking', route: 'locations' },
      { icon: 'contacts', text: 'Kunden', route: 'customer' },
      { icon: 'local_shipping', text: 'Touren', route: 'tours' },
      { icon: 'assignment', text: 'Aufträge', route: 'contracts' },
      { icon: 'people', text: 'Fahrer', route: 'drivers' },
      { icon: 'important_devices', text: 'Geräte', route: 'devices' },
      { icon: 'account_circle', text: 'Benutzer', route: 'users' },
      { icon: 'help', text: 'Updates', route: 'updates' }
    ]
  }),
  methods: {
    goToCustomer(route) {
      router.push({ name: route });
    },
    logoutClick() {
      localStorage.removeItem('user');
      router.push({ name: 'login' });
    },
    init() {
      router.push({ name: 'dashboard' });
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'));
    }
  },
  props: {
    source: String
  },
  watch: {
    shortcutTextfield: function(newValue, oldValue) {
      var loadno = newValue;

      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };

      if (loadno.length < 5 || loadno === null) {
        this.shortcutTextfieldErrorMessage = '';
        this.shortcutTextfieldError = false;
        return;
      }
      this.$store.dispatch('locations/getLoadnoSpecific', { loadno });
      fetch(
        `${settings.apiUrl}/tours/loadno/complete/` + loadno,
        requestOptions
      ).then(response =>
        response.json().then(json => {
          console.log(json);
          console.log(response);
          if (response.ok) {
            this.$store.dispatch('tours/getCompleteTour', { loadno });
            this.shortcutTextfieldError = false;
            this.shortcutTextfieldErrorMessage = '';
            this.showDetail = true;
            this.tourDetailKey += 1;
            this.shortcutTextfield = '';
          } else {
            this.shortcutTextfieldError = true;
            this.shortcutTextfieldErrorMessage = 'Nicht gefunden';
          }
        })
      );
    }
  }
};
</script>
<style scoped>
.activated {
  color: #1565c0 !important;
}
.notActivated {
  color: black;
  text-decoration: none;
}
</style>
